module.exports = __webpack_public_path__ + "static/MOD6-1e6977e2d29d3f4a13057c7a93f0e924.jpg";